import { useAppSelector } from "../app/hooks";
import { selectUserInformations } from "../services/userSlice";

export const useAuth = () => {
	const userInformations = useAppSelector(selectUserInformations);
	
	return {
		isAuthenticated: userInformations?.isAuthenticated ?? false,
		userIds: userInformations?.userIds,
		userInformations,
	};
};